export const streetVendorTypes = [
    "Other",
    "Lemonade Stand",
    "Hot Dog Cart",
    "Taco Truck",
    "Ice Cream Truck",
    "Food Truck",
    "Pizza Stand",
    "BBQ Stand",
    "Coffee Cart",
    "Juice Bar",
    "Smoothie Stand",
    "Bakery Stand",
    "Donut Cart",
    "Pretzel Stand",
    "Churro Stand",
    "Fruit Stand",
    "Vegetable Stand",
    "Farmers' Market Vendor",
    "Popcorn Stand",
    "Cotton Candy Cart",
    "Crepe Stand",
    "Waffle Stand",
    "Candy Stand",
    "Cupcake Stand",
    "Muffin Cart",
    "Pie Stand",
    "Catering Vendor",
    "Kebab Stand",
    "Falafel Cart",
    "Shawarma Stand",
    "Seafood Stand",
    "Sushi Cart",
    "Pasta Stand",
    "Burger Stand",
    "Sandwich Stand",
    "Salad Bar",
    "Soup Stand",
    "Ramen Cart",
    "Pho Stand",
    "BBQ Ribs Stand",
    "Taco Stand",
    "Burrito Cart",
    "Tamale Stand",
    "Empanada Stand",
    "Quesadilla Stand",
    "Chili Stand",
    "Street Tacos",
    "Fish and Chips Stand",
    "Clam Chowder Stand",
    "Gumbo Stand",
    "Crawfish Boil",
    "Hot Wings Stand",
    "Bratwurst Cart",
    "Corn Dog Stand",
    "Roasted Corn Stand",
    "Street Corn (Elote) Stand",
    "Fried Chicken Stand",
    "Chicken and Waffles Stand",
    "Gourmet Hot Dogs",
    "Vegan Food Truck",
    "Vegetarian Stand",
    "Gluten-Free Food Stand",
    "Keto Food Stand",
    "Paleo Food Stand",
    "Street Pizza",
    "Artisan Bread Stand",
    "Bagel Stand",
    "Cheese Stand",
    "Artisan Chocolate Stand",
    "Cookie Stand",
    "Scone Stand",
    "Brownie Stand",
    "Macaron Stand",
    "Gourmet Popsicle Stand",
    "Frozen Yogurt Stand",
    "Gelato Cart",
    "Sorbet Stand",
    "Slushie Stand",
    "Iced Tea Stand",
    "Coffee Stand",
    "Espresso Cart",
    "Nitro Cold Brew Stand",
    "Craft Beer Stand",
    "Wine Tasting Stand",
    "Cocktail Stand",
    "Mocktail Stand",
    "Tea Stand",
    "Bubble Tea Cart",
    "Herbal Tea Stand",
    "Sake Stand",
    "Kombucha Stand",
    "Homebrewed Beer Stand",
    "Cocktail Tasting Stand",
    "Spirits Tasting Stand",
    "Whiskey Tasting Stand",
    "Cider Stand",
    "Mead Stand",
    "Liqueur Stand",
    "Vodka Stand",
    "Gin Stand",
    "Rum Stand",
    "Bourbon Stand",
    "Craft Soda Stand",
    "Energy Drink Stand",
    "Smoothie Bowl Stand",
    "Acai Bowl Stand",
    "Poke Bowl Stand",
    "Sushi Burrito Stand",
    "Sushi Roll Stand",
    "Street Noodles Stand",
    "Dumpling Stand",
    "Bao Bun Stand",
    "Dim Sum Cart",
    "Korean BBQ Stand",
    "Bibimbap Stand",
    "Bulgogi Stand",
    "Japchae Stand",
    "Kimchi Stand",
    "Udon Noodle Stand",
    "Pad Thai Stand",
    "Satay Stand",
    "Spring Roll Stand",
    "Vietnamese Sandwich (Banh Mi) Stand",
    "Street Tofu Stand",
    "Paneer Stand",
    "Samosa Stand",
    "Indian Street Food Stand",
    "Chaat Stand",
    "Pani Puri Stand",
    "Dosa Cart",
    "Naan Stand",
    "Pita Bread Stand",
    "Falafel Stand",
    "Hummus Stand",
    "Baba Ganoush Stand",
    "Tabbouleh Stand",
    "Greek Street Food Stand",
    "Gyro Stand",
    "Souvlaki Stand",
    "Baklava Stand",
    "Dolma Stand",
    "Feta Cheese Stand",
    "Olive Stand",
    "Caprese Salad Stand",
    "Prosciutto Stand",
    "Bruschetta Stand",
    "Panini Stand",
    "Pasta Salad Stand",
    "Italian Sausage Stand",
    "Risotto Stand",
    "Gelato Stand",
    "Tiramisu Stand",
    "Cannoli Stand",
    "Caviar Stand",
    "Oyster Bar",
    "Ceviche Stand",
    "Seaweed Salad Stand",
    "Tuna Tartare Stand",
    "Lobster Roll Stand",
    "Clam Bake Stand",
    "Fish Taco Stand",
    "Calamari Stand",
    "Crab Cake Stand",
    "Shrimp Cocktail Stand",
    "Scallop Stand",
    "Lobster Stand",
    "Crab Stand",
    "Oyster Stand",
    "Gourmet Grilled Cheese Stand",
    "Artisan Sausage Stand",
    "Charcuterie Stand",
    "Gourmet Cheese Stand",
    "Gourmet Popcorn Stand",
    "Caramel Apple Stand",
    "Chocolate Fountain Stand",
    "Apple Cider Stand",
    "Coconut Water Stand",
    "Street Photography Stand",
    "Handmade Jewelry Stand",
    "Art Stand",
    "Crafts Stand",
    "Woodworking Stand",
    "Handmade Soap Stand",
    "Candle Stand",
    "Perfume Stand",
    "Essential Oils Stand",
    "Vintage Clothing Stand",
    "Thrift Store Pop-Up",
    "Yard Sale",
    "Antique Stand",
    "Record Stand",
    "Book Stand",
    "Comic Book Stand",
    "Toy Stand",
    "Board Game Stand",
    "Puzzle Stand",
    "Video Game Stand",
    "Retro Game Stand",
    "Gaming Console Stand",
    "Phone Accessories Stand",
    "Electronics Stand",
    "Custom T-Shirts Stand",
    "Hat Stand",
    "Shoes Stand",
    "Bag Stand",
    "Luggage Stand",
    "Sunglasses Stand",
    "Watch Stand",
    "Bicycle Repair Stand",
    "Skateboard Repair Stand",
    "Bike Accessories Stand",
    "Skateboard Accessories Stand",
    "Scooter Stand",
    "Rollerblades Stand",
    "Surfboard Stand",
    "Kayak Stand",
    "Canoe Stand",
    "Outdoor Gear Stand",
    "Camping Gear Stand",
    "Fishing Gear Stand",
    "Sports Equipment Stand",
    "Fitness Equipment Stand",
    "Yoga Gear Stand",
    "Meditation Supplies Stand",
    "Pet Supplies Stand",
    "Dog Treats Stand",
    "Cat Treats Stand",
    "Bird Supplies Stand",
    "Fish Supplies Stand",
    "Reptile Supplies Stand",
    "Pet Grooming Stand",
    "Pet Clothing Stand",
    "Pet Accessories Stand",
    "Plant Stand",
    "Succulent Stand",
    "Flower Stand",
    "Herb Stand",
    "Tree Stand",
    "Seed Stand",
    "Gardening Tools Stand",
    "Soil Stand",
    "Compost Stand",
    "Hydroponic Supplies Stand",
    "Aquaponic Supplies Stand",
    "Halal Cart",
    "Breakfast Cart",
    "Peanut Stand",
    "Filipino food",
    "Filipino BBQ",
    "Canoli Truck"
];